import React, { useCallback, useMemo } from 'react';
import Select from 'apollo-react/components/Select';
import MenuItem from 'apollo-react/components/MenuItem';
import FieldWrapper from '../../fields/FieldWrapper';

const SelectFieldInput = ({
  id,
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  helperText,
  showError,
  disabled,
  required,
  columnStyle,
  options,
  multiple = false,
}) => {
  const handleChange = useCallback(
    (e) => {
      if (onChange) onChange(e);
    },
    [onChange]
  );

  // Multi-select works on an array of option values (a legacy single value is wrapped).
  // IDS Select renders the checkboxes and the selected labels itself in `multiple` mode.
  const selectValue = useMemo(() => {
    if (!multiple) return value || '';
    if (Array.isArray(value)) return value;
    return value ? [value] : [];
  }, [multiple, value]);

  return (
    <FieldWrapper style={columnStyle}>
      <Select
        id={id}
        name={id}
        label={label}
        placeholder={
          placeholder || (multiple ? 'Select options' : 'Select an option')
        }
        value={selectValue}
        onChange={handleChange}
        onBlur={onBlur}
        helperText={helperText}
        error={showError}
        disabled={disabled}
        required={required}
        multiple={multiple}
        // Deselecting a value in multi mode is a normal toggle, not "clear the field"
        canDeselect={!multiple}
        fullWidth
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FieldWrapper>
  );
};

export default SelectFieldInput;
